import React, { useState } from 'react';
import { validateFunctionalForm } from '../../../utils';

const EXPENSE_CODE_MAX_LENGTH = 10;

const ExpenseTypeForm = (props) => {
    const [state, setState] = useState({
        expenseTypeName: { name: 'expenseTypeName', value: props.data?.EXPENSE_TYPE_NAME || '', isRequired: true, error: '' },
        expenseCode: { name: 'expenseCode', value: props.data?.EXPENSE_CODE || '', isRequired: true, error: '' },
        description: { name: 'description', value: props.data?.DESCRIPTION || '', isRequired: false, error: '' },
        isReimbursable: { name: 'isReimbursable', value: props.data?.IS_REIMBURSABLE || false, isRequired: false },
        isTaxable: { name: 'isTaxable', value: props.data?.IS_TAXABLE || false, isRequired: false },
        isActive: { name: 'isActive', value: props.data?.IS_ACTIVE ?? true, isRequired: false }
    });

    const onChange = (e) => {
        const { name, value, type, checked } = e.target;
        const val = type === 'checkbox' ? checked : value;
        setState(prev => ({
            ...prev,
            [name]: {
                ...prev[name],
                value: val,
                error: prev[name].isRequired && !val
                    ? 'This field is required'
                    : name === 'expenseCode' && String(val).trim().length > EXPENSE_CODE_MAX_LENGTH
                        ? `Expense code cannot be more than ${EXPENSE_CODE_MAX_LENGTH} characters`
                        : ''
            }
        }));
    };

    const onSubmit = (e) => {
        e.preventDefault();
        const expenseCode = String(state.expenseCode.value || '').trim();
        if (expenseCode.length > EXPENSE_CODE_MAX_LENGTH) {
            setState(prev => ({
                ...prev,
                expenseCode: {
                    ...prev.expenseCode,
                    error: `Expense code cannot be more than ${EXPENSE_CODE_MAX_LENGTH} characters`
                }
            }));
            return;
        }

        if (validateFunctionalForm(state, setState)) {
            const model = {
                expenseTypeName: String(state.expenseTypeName.value || '').trim(),
                expenseCode,
                description: String(state.description.value || '').trim(),
                isReimbursable: state.isReimbursable.value,
                isTaxable: state.isTaxable.value,
                isActive: state.isActive.value
            };
            if (props.data?.ID) model.id = props.data.ID;
            props.onSubmit(model);
        }
    };

    return (
        <form onSubmit={onSubmit}>
            <h4 className="card-title mb-4">{props.title || 'Expense Type Form'}</h4>
            <div className="row">
                {[ 
                    { label: 'Expense Type Name', name: 'expenseTypeName', placeholder: 'Enter expense type name' },
                    { label: 'Expense Code', name: 'expenseCode', placeholder: 'Enter unique expense code', maxLength: EXPENSE_CODE_MAX_LENGTH }
                ].map(({ label, name, type = 'text', placeholder, maxLength }) => (
                    <div className="col-md-6 mb-3" key={name}>
                        <label>{label} {state[name].isRequired && <span className='text-danger'> *</span>}</label>
                        <input
                            type={type}
                            name={state[name].name}
                            value={state[name].value}
                            onChange={onChange}
                            placeholder={placeholder}
                            maxLength={maxLength}
                            className={state[name].error ? "form-control is-invalid" : "form-control"}
                        />
                        {state[name].error && <div className="invalid-feedback">{state[name].error}</div>}
                    </div>
                ))}

                <div className="col-md-12 mb-3">
                    <label>Description</label>
                    <textarea
                        name={state.description.name}
                        value={state.description.value}
                        onChange={onChange}
                        placeholder="Enter description (optional)"
                        className="form-control"
                        rows={3}
                    />
                </div>

                <div className='row ms-2'>
                    {[
                        { label: 'Reimbursable', name: 'isReimbursable' },
                        { label: 'Taxable', name: 'isTaxable' },
                        { label: 'Active', name: 'isActive' }
                    ].map(({ label, name }) => (
                        <div className="col-md-4 mb-3 form-check" key={name}>
                            <input
                                type="checkbox"
                                name={state[name].name}
                                checked={state[name].value}
                                onChange={onChange}
                                className="form-check-input"
                                id={name}
                            />
                            <label className="form-check-label" htmlFor={name}>{label}</label>
                        </div>
                    ))}
                </div>
            </div>
            <div className="mt-3">
                <button type="submit" className="btn btn-success me-2">Save</button>
                <button type="reset" className="btn btn-danger"
                                        onClick={() => window.history.back()}
                
                >Cancel</button>
            </div>
        </form>
    );
};

export default ExpenseTypeForm;
